import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "fc_cookie_consent_v1";

export default function CookieBanner({ onOpenPrivacy }) {
    const [shown, setShown] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem(KEY);
        if (!stored) {
            const t = setTimeout(() => setShown(true), 1200);
            return () => clearTimeout(t);
        }
    }, []);

    const decide = (choice) => {
        localStorage.setItem(
            KEY,
            JSON.stringify({ choice, at: new Date().toISOString() })
        );
        setShown(false);
        if (choice === "rejected" && typeof window !== "undefined" && window.posthog) {
            try { window.posthog.opt_out_capturing(); } catch (_) {}
        }
        if (choice === "accepted" && typeof window !== "undefined" && window.posthog) {
            try { window.posthog.opt_in_capturing(); } catch (_) {}
        }
    };

    return (
        <AnimatePresence>
            {shown && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
                    className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[70] bg-ink-900/95 backdrop-blur-xl border border-white/15 p-5 md:p-6 shadow-2xl"
                    data-testid="cookie-banner"
                    role="dialog"
                    aria-live="polite"
                    aria-label="Consenso cookie"
                >
                    <div className="overline mb-3">
                        <span className="text-flash">■</span>&nbsp;&nbsp;Cookie &amp; Privacy
                    </div>
                    <p className="text-bone-200 font-light text-sm leading-relaxed mb-5">
                        Utilizzo cookie tecnici (essenziali) e, previo tuo consenso, cookie di
                        analytics anonimi (PostHog) per capire come viene usato il sito.
                        Nessun dato viene condiviso a fini pubblicitari.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <button
                            onClick={() => decide("accepted")}
                            className="btn-flash justify-center flex-1"
                            data-testid="cookie-accept"
                        >
                            <span>Accetto tutti</span>
                            <span>→</span>
                        </button>
                        <button
                            onClick={() => decide("rejected")}
                            className="font-mono text-[11px] tracking-[0.2em] uppercase text-bone-400 hover:text-bone-50 transition-colors px-4 py-3 border border-white/15 hover:border-white/40 flex-1"
                            data-testid="cookie-reject"
                        >
                            Solo essenziali
                        </button>
                    </div>
                    <button
                        onClick={onOpenPrivacy}
                        className="mt-4 font-mono text-[10px] tracking-[0.2em] uppercase text-bone-400 link-underline"
                        data-testid="cookie-privacy-link"
                    >
                        Leggi la privacy policy ↗
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
